module.exports = __webpack_public_path__ + "static/media/need-coping.a8c99ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-coping.jpg
// module id = 366
// module chunks = 0